// api/terminalApi.js
import axiosInstance from './axiosConfig';
import ApiConfig from './config';
import { ConflictError } from './errors';

export const getTerminals = async (businessId) => {
  try {
    const response = await axiosInstance.get(ApiConfig.ENDPOINTS.GET_TERMINALS, {
      params: { businessId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getFeeCaps = async (businessId) => {
  try {
    const response = await axiosInstance.get(ApiConfig.ENDPOINTS.GET_FEECAPS, {
      params: { businessId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSingleTerminal = async (Id) => {
  try {
    const response = await axiosInstance.get(ApiConfig.ENDPOINTS.GET_SINGLE_TERMINAL, {
      params: { id: Id }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const addOrUpdateTerminal = async (businessId, data) => {
  try {
    if (!businessId) {
      throw new Error('Business ID is required');
    }

    const payload = Array.isArray(data) ? data : [data];

    const response = await axiosInstance.post(
      `${ApiConfig.ENDPOINTS.UPSERT_TERMINAL}?businessId=${encodeURIComponent(businessId)}`,
      payload
    );

    return response.data;
  } catch (error) {
    // Check for 409 conflict
    if (error.response?.status === 409) {
      const data = error.response.data || {};
      throw new ConflictError(
        data.detail || data.message || 'Conflict detected',
        data
      );
    }
    throw error;
  }
};

// Clear Terminal Login Attempts
export const clearTerminalLoginAttempts = async (terminalId) => {
  try {
    if (!terminalId) {
      throw new Error('Terminal ID are required');
    }

    const response = await axiosInstance.put(
      ApiConfig.ENDPOINTS.CLEAR_TERMINALS_LOGIN_ATTEMPTS,
      {
        acquirerTId: terminalId
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create Enrolment Code
export const createEnrolmentCode = async (id) => {
  try {

    if (!id) {
      throw new Error('ID are required');
    }

    const response = await axiosInstance.put(
      ApiConfig.ENDPOINTS.CREATE_ENROLMENT_CODE,
      null,
      {
        params: {
          id: id
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};